import { render, staticRenderFns } from "./AsmtPrintPassage.vue?vue&type=template&id=dadf2546"
import script from "./AsmtPrintPassage.vue?vue&type=script&lang=ts"
export * from "./AsmtPrintPassage.vue?vue&type=script&lang=ts"
import style0 from "./AsmtPrintPassage.vue?vue&type=style&index=0&id=dadf2546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports